module.exports = __webpack_public_path__ + "static/img/moaInstallForWin_pic03.4dd1ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForWin/moaInstallForWin_pic03.png
// module id = 537
// module chunks = 1